module.exports = __webpack_public_path__ + "static/img/252.c99e3c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/news/252.png
// module id = J5d0
// module chunks = 0